import { stock } from '@/data/stockImages';

// Problem çözme (D). Hedef: kafe stok takibi, restoran stok takibi, stok takibi nasıl yapılır.
export default [
  {
    t: 'p',
    text: 'Kafe ve restoran stok takibi, elinizdeki malzeme miktarını düzenli olarak kayda geçirip satışlarla karşılaştırmaktır. Üç parçası vardır: gelen malın girişi, satılan ürünlerin stoktan düşülmesi ve belirli aralıklarla yapılan sayım. Sayımda çıkan miktar ile kayıttaki miktar arasındaki fark, fire, israf ya da kayıp hakkında size bilgi verir.',
  },
  {
    t: 'p',
    text: 'Bu yazıda stoğun neden tutmadığını, takibin nasıl kurulacağını ve kafe ile restoranda öne çıkan farkları anlatıyoruz.',
  },
  { t: 'h2', text: 'Stok neden tutmaz?' },
  {
    t: 'p',
    text: 'Kayıttaki miktar ile raftaki miktarın farklı çıkması kafe ve restoranlarda neredeyse her zaman yaşanır. Sebepleri genellikle şunlardır:',
  },
  {
    t: 'list',
    items: [
      '**Ölçüsüz hazırlık:** Reçetede 200 ml süt yazıyorsa ama bardak göz kararı dolduruluyorsa, her satışta küçük bir fark birikir.',
      '**Kayda geçmeyen fire:** Dökülen süt, yanan bir porsiyon, son kullanma tarihi geçen ürün çoğu zaman yazılmaz.',
      '**İkram ve personel tüketimi:** Bunlar satış olarak girilmediğinde stoktan düşmez.',
      '**Eksik giriş:** Gelen mal kayda geçmediyse, sistem stoğu olduğundan az gösterir; sonraki sayımda fark ters yönde çıkar.',
    ],
  },
  {
    t: 'p',
    text: 'Bu farkların hepsini ortadan kaldırmak mümkün değil. Amaç, farkı görünür hâle getirmek ve hangi kalemde büyüdüğünü fark etmektir.',
  },
  { t: 'h2', text: 'Stok takibi nasıl kurulur?' },
  {
    t: 'steps',
    items: [
      {
        title: 'Stok kalemlerini listeleyin',
        text: 'Ürünlerinizi değil, onları hazırlarken kullandığınız malzemeleri girin: kahve çekirdeği, süt, şurup, un, et, sebze, ambalaj. Her kalemin birimini (kg, litre, adet) baştan belirleyin ve değiştirmeyin.',
      },
      {
        title: 'Açılış sayımı yapın',
        text: 'Takibe başladığınız gün elinizdeki miktarları sayıp girin. Sonraki bütün hesaplar bu ilk sayımın üzerine kurulur.',
      },
      {
        title: 'Ürünlere reçete tanımlayın',
        text: 'Her ürün için hangi malzemeden ne kadar kullanıldığını girin. Örneğin bir latte için 18 g kahve ve 200 ml süt. Reçete tanımlandığında her satış stoktan otomatik düşer.',
      },
      {
        title: 'Gelen malı giriş olarak kaydedin',
        text: 'Tedarikçiden mal geldiğinde miktarı ve alış fiyatını girin. Fiyatın girilmesi, ürün maliyetinin hesaplanabilmesi için gereklidir.',
      },
      {
        title: 'Uyarı eşiği belirleyin',
        text: 'Her kalem için “bunun altına düşerse sipariş verilmeli” dediğiniz miktarı girin. Tedarik süresi uzun olan kalemlerde eşiği daha yüksek tutun.',
      },
      {
        title: 'Düzenli sayım yapın',
        text: 'Sayılan miktarı sisteme girdiğinizde kayıt düzeltilir ve aradaki fark kayda geçer. Hızlı tükenen ve pahalı kalemleri daha sık, diğerlerini daha seyrek saymak pratik bir yaklaşımdır.',
      },
    ],
  },
  { t: 'h2', text: 'Sayım farkı nasıl yorumlanır?' },
  {
    t: 'p',
    text: 'Sayım farkı tek başına bir şey söylemez; hangi kalemde ve ne sıklıkla çıktığına bakmak gerekir. Aşağıdaki örnek bir haftalık sayımı gösteriyor:',
  },
  {
    t: 'table',
    head: ['Kalem', 'Kayıttaki', 'Sayılan', 'Fark', 'Olası neden'],
    rows: [
      ['Süt', '42 L', '38 L', '−4 L', 'Ölçüsüz doldurma, köpürtmede fazla süt'],
      ['Kahve çekirdeği', '6,0 kg', '5,8 kg', '−0,2 kg', 'Ayar sırasında atılan shot’lar'],
      ['Cheesecake', '14 dilim', '12 dilim', '−2 dilim', 'Kayda geçmeyen ikram ya da fire'],
      ['Karton bardak', '300 adet', '320 adet', '+20 adet', 'Girişte eksik kayıt'],
    ],
    caption: 'Örnek sayım tablosu. Rakamlar açıklama amaçlıdır.',
  },
  {
    t: 'p',
    text: 'Süt örneğinde litresi 45 TL’den 4 litrelik fark haftada 180 TL eder. Tek başına küçük görünse de ay sonunda 700 TL’yi geçer. Farkın her hafta aynı kalemde tekrar etmesi, reçetenin ya da hazırlık alışkanlığının gözden geçirilmesi gerektiğini gösterir. Artı yönde çıkan fark ise çoğunlukla bir girişin unutulduğu anlamına gelir.',
  },
  { t: 'h2', text: 'Kafede stok takibi' },
  {
    t: 'img',
    img: stock('latte', 'Latte art ile servis edilen sütlü kahve'),
  },
  {
    t: 'p',
    text: 'Kafelerde stok kalemi sayısı azdır ama aynı malzeme çok sayıda üründe kullanılır. Süt; latte, cappuccino, flat white ve sütlü soğuk içeceklerin hepsine girer. Bu yüzden reçeteli takip kafede hızlı sonuç verir: birkaç kalemin reçetesini doğru girmek, stoğun büyük kısmını kapsar. Karton bardak, kapak ve pipet gibi ambalajları da stok kalemi olarak tutmak, paket satışın gerçek maliyetini görmeyi sağlar.',
  },
  { t: 'h2', text: 'Restoran stok takibi' },
  {
    t: 'img',
    img: stock('salata-kase', 'Tavuklu, sebzeli salata kasesi'),
  },
  {
    t: 'p',
    text: 'Restoranlarda kalem sayısı fazladır ve malzemelerin önemli bir kısmı çabuk bozulur. Burada iki konu öne çıkar. Birincisi, önce gelen malın önce kullanılması; eski partinin arkada kalıp bozulması, restoranlarda firenin en yaygın sebeplerinden biridir. İkincisi, et ve balık gibi temizlendikten sonra ağırlık kaybeden malzemelerde reçeteye temizlenmiş ağırlığın yazılması. Bu ayrım maliyet hesabını da doğrudan etkiler; ayrıntısı [ürün maliyeti nasıl hesaplanır](/blog/urun-maliyeti-nasil-hesaplanir) yazısında.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da stok ve reçete' },
  {
    t: 'p',
    text: 'Tilki’de ürünlere reçete tanımladığınızda her satış stoktan düşer ve uyarı eşiğinin altına inen kalemler kritik stok olarak işaretlenir. “Giriş” ile gelen malı alış fiyatıyla, “Sayım” ile elde sayılan miktarı girersiniz; sayım farkı hareket geçmişinde ayrı satır olarak görünür. Stok, önce gelen partiden tüketilir; bu yüzden ürün maliyeti güncel alış fiyatlarıyla hesaplanır.',
  },
  {
    t: 'guide',
    image: '33-stok-recete',
    alt: 'Stok ekranında stok kalemleri, kritik stok uyarısı, giriş ve sayım butonları',
    caption: 'Stok ekranı: kalemler, kritik stok uyarısı, giriş ve sayım.',
  },
  {
    t: 'cta',
    title: 'Stoğunuzu satışla birlikte takip edin',
    text: 'Ücretsiz demo talep edin; birkaç ürününüzün reçetesini birlikte girip stok düşümünü gösterelim.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Restoran stok takibi programı ne işe yarar?',
    a: 'Reçete tanımlanan ürünlerde her satışı stoktan düşer, azalan kalemler için uyarı verir ve sayım farklarını kayda geçirir. Böylece hangi malzemenin ne kadar kullanıldığı ve nerede fire oluştuğu elle hesaplamadan görünür.',
  },
  {
    q: 'Stok sayımı ne sıklıkla yapılmalı?',
    a: 'Tek bir doğru sıklık yok. Pahalı ve hızlı tükenen kalemleri (kahve, süt, et) haftalık, diğerlerini aylık saymak birçok işletmede pratik bir başlangıçtır. Farkların büyüdüğü kalemlerde sıklığı artırabilirsiniz.',
  },
  {
    q: 'Reçete tanımlamadan stok takibi yapılabilir mi?',
    a: 'Yapılabilir, ama bu durumda stok yalnızca giriş ve sayımla güncellenir; satışlar stoğu otomatik düşürmez. Ne kadar kullandığınızı ancak iki sayım arasındaki farktan anlarsınız, hangi ürünün ne kadar tükettiğini göremezsiniz.',
  },
  {
    q: 'Fire nasıl azaltılır?',
    a: 'Önce firenin nerede oluştuğunu görmek gerekir. Sayım farklarını kalem bazında izlemek, reçeteleri ölçülü hazırlığa göre düzenlemek, önce gelen malı önce kullanmak ve ikramları kayda geçirmek en etkili adımlardır.',
  },
];
